import { renderFormatMessage } from 'helpers/intl'

interface FreeListingProps {
  isLargeScreen: string
  isSmallScreen: string
  pricingSchemaIncluded?: boolean
}

export const FreeListing: React.FC<FreeListingProps> = ({
  isLargeScreen,
  isSmallScreen,
  pricingSchemaIncluded = true,
}) => (
  <div className={isLargeScreen}>
    <div className={isSmallScreen}>
      {pricingSchemaIncluded
        ? renderFormatMessage('dashboard.transactionsPage.advancedSearch.state.free', 'Free')
        : renderFormatMessage('dashboard.transactionsPage.advancedSearch.state.pricingPending', 'Pricing Pending')}
    </div>
  </div>
)
